/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { themeOpts as baseTheme } from '@mayoral/ui/theme/hugandclau';
import { createTheme, ThemeOptions } from '@mui/material/styles';
import { merge } from 'lodash';

// FIXME:(themes): remove this temporary fix once the issue with the secondary button color is resolved in the base theme in registry
// This is a temporary fix to override the secondary button color.
const themeOverrides: ThemeOptions = {
  components: {
    MuiButton: {
      styleOverrides: {
        containedSecondary: {
          backgroundColor: baseTheme.palette.secondary[900],
          '&:hover': {
            backgroundColor: baseTheme.palette.secondary[600],
          },
        },
      },
    },
  },
};

const theme = createTheme(merge({}, baseTheme, themeOverrides));

export default theme;
